import React, { useState, useEffect } from "react";
import {
  Form,
  Modal,
  Row,
  Col,
  Container,
  Table,
  Button,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Helpers from "../../../components/Helpers";
import uploadRetreat from "../../../assets/images/uploadRetreat.png";
import Profile from "../../../assets/images/couple-default.png";
import Select from "react-select";
import { Link } from "react-router-dom";
import fbIcon from "../../../assets/images/fb.jpeg";
import instaIcon from "../../../assets/images/instagram.png";
import ProgramApi from "../../../api/programApi";
import AdminApi from "../../../api/admin";
import RolesApi from "../../../api/RolesApi";
import TalksApi from "../../../api/TalksApi";
import ServiceApi from "../../../api/ServiceApi";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import ProgramModel from "./ProgramModel";
import TalkWorksheetEditor from "./TalkWorksheetEditor";
import TalkWorksheet from "../../../components/TalkWorksheet";
import {
  speakerDisplayName,
  talkHeading,
} from "../../../utils/talkWorksheet";
import Loader from "../../../components/loader";
import DeleteModel from "../../../components/DeleteModel";
import AlertConfirm from "../../../components/AlertConfirm";
import { Cookies } from "react-cookie";
import RetreatApi from "../../../api/retreatApi";
import ImagePlaceHolder from "../../../assets/images/image-placeholder.png";
import lovestrongLogo from "../../../assets/images/logolovestrong.png";
import PriestApi from "../../../api/priestApi";
import defaultQrCode from "../../../assets/images/Lovestrong QR.png";
const talkOrder = [
  "Holy Matrimony: God, Husband & Wife",
  "The Sacrament of Marriage",
  "Understanding Yourself, Understanding Your Spouse",
  "Communication",
  "Challenges in Marriage",
  "Children and In-Laws",
  "Sex and Marriage",
  "Marital Bliss",
  "Forgiveness",
  "Us vs. the World",
  "Go Forth With God",
];

export const CreateProgram = () => {
  let programApi = new ProgramApi();
  let priestApi = new PriestApi();
  let adminApi = new AdminApi();
  let rolesApi = new RolesApi();
  let talksApi = new TalksApi();
  let serviceApi = new ServiceApi();
  let retreatApi = new RetreatApi();
  let cookies = new Cookies();
  let userData = cookies.get("LoveStrongUser") || null;
  const { t, i18n } = useTranslation();
  const { id } = useParams();

  const [program, setProgram] = useState([]);
  const [roasterData, setRoasterData] = useState([]);
  const [isTempUpload, setIsTempUpload] = useState(false);
  const [modalProramShow, setModalProramShow] = useState(false);
  const [nameModel, setNameModel] = useState("");
  const [coupleTalkData, setCoupleTalkData] = useState([]);
  const [worksheetTalk, setWorksheetTalk] = useState(null);
  const [allCoupleData, setAllCoupleData] = useState([]);
  const [rolesDataList, setRolesDataList] = useState([]);
  const [talksDataList, setTalksDataList] = useState([]);
  const [serviceDataList, setServiceDataList] = useState([]);
  const [roleSelect, setRoleSelect] = useState([]);
  const [coupleSelectForRole, setCoupleSelectForRole] = useState([]);
  const [talkSelect, setTalkSelect] = useState([]);
  const [coupleSelectForTalk, setCoupleSelectForTalk] = useState([]);
  const [serviceSelect, setServiceSelect] = useState([]);
  const [coupleSelectForService, setCoupleSelectForService] = useState([]);
  const [LoadData, setLoadData] = useState(false);
  const [roleGreenTick, setRoleGreenTick] = useState(false);
  const [talkGreenTick, setTalkGreenTick] = useState(false);
  const [serviceGreenTick, setServiceGreenTick] = useState(false);
  const [deleteItm, setDeleteItm] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);
  const [priestSelectForRole, setPriestSelectForRole] = useState([]);
  const [priestsList, setPriestsList] = useState([]);
  const [formattedPriestsList, setFormattedPriestsList] = useState([]);
  const [isSpiritualDirector, setIsSpiritualDirector] = useState(false);
  const [endingPageBgColor, setEndingPageBgColor] = useState("#1f4e7a");
  const [showColorAlert, setShowColorAlert] = useState(false);
  const [tempColor, setTempColor] = useState("");

  const isSpanish = data?.language?.toLowerCase() === "spanish";

  // Global i18n instance should stay in the admin's language (usually English).
  // We use a helper for the preview section to show retreat-specific language.
  const tp = (key, options = {}) => {
    const lang =
      data?.language?.toLowerCase() === "spanish" ? "spanish" : "english";
    return t(key, { ...options, lng: lang });
  };

  useEffect(() => {
    getProgramDetail(id);
    getAllCouples();
    getrolesList();
    getAllRoastersInfo(id);
    getTalksList();
    getServiceList();
    getRetreatDetail(id);
    getPriestsList();
  }, [id]);

  // Builds a map of section key -> page number.
  // Page 1 = Cover, Page 2 = TOC, Page 3 = Opening Prayer,
  // then each subsequent section that exists adds one more page.
  // Parish Mission is always shown so it always gets a page.
  const buildPageMap = () => {
    const map = {};
    let page = 1;

    map["cover"] = page++; // Page 1
    map["toc"] = page++; // Page 2
    map["openingPrayer"] = page++; // Page 3

    if (roasterData?.[0]?.role?.length > 0) map["retreatLeadTeam"] = page++;
    if (roasterData?.[1]?.speakers?.length > 0) map["speakersTeam"] = page++;
    if (roasterData?.[2]?.services?.length > 0) map["supportTeams"] = page++;

    if (program?.wisdom_from_mt) map["wisdom"] = page++;

    if (program?.guidelines) map["guidelines"] = page++;

    const speakers = roasterData?.[1]?.speakers || [];
    speakers.forEach((_, i) => {
      map[`talk_${i}`] = page++;
    });

    map["parishMission"] = page++; // always rendered
    map["prayerOfProtection"] = page++;
    map["donations"] = page++;

    if (program?.footerImages?.length > 0) {
      program.footerImages.forEach((_, idx) => {
        map[`footer_${idx}`] = page++;
      });
    }

    map["endingPage"] = page++;

    map["total"] = page - 1;
    return map;
  };

  const getRetreatDetail = async (id) => {
    await retreatApi
      .getRetreatDetail({ id: id })
      .then((res) => {
        if (res.success) {
          const { schedule, ...rest } = res.data[0];
          const parsedSchedule = schedule ? JSON.parse(schedule) : [];
          const parsedData = {
            ...rest,
            schedule: parsedSchedule.map((entry) => ({
              date: new Date(entry.date),
              from: entry.from,
              to: entry.to,
            })),
            parish: res.data[0].parishId,
          };
          setData(parsedData);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const getPriestsList = async () => {
    try {
      let d = {};
      d.pageNo = 1;
      d.size = 20;
      d.export = true;
      const res = await priestApi.getAllPriests(d);
      if (res.success && res.data) {
        setPriestsList(res.data);
        const priestOptions = (res.data || []).map((p) => ({
          label:
            [p.title, p.firstName, p.lastName].filter(Boolean).join(" ") +
            (p.parish ? ` (${p.parish})` : ""),
          value: p.id,
        }));
        setFormattedPriestsList(priestOptions);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getAllCouples = async () => {
    await adminApi
      .allCouples()
      .then((res) => {
        if (res.success) {
          let allcoupleList = [];
          res.data &&
            res.data.forEach((item) => {
              if (item.hisFirstName) {
                allcoupleList.push({
                  label:
                    item?.hisFirstName && item?.herFirstName
                      ? `${item.hisLastName || ""}, ${item.hisFirstName} and ${item.herFirstName}`
                      : item?.hisFirstName
                        ? `${item.hisLastName || ""}, ${item.hisFirstName}`
                        : item?.herFirstName
                          ? `${item.herLastName || ""}, ${item.herFirstName}`
                          : "",
                  value: item.id,
                });
              }
            });
          const sort = allcoupleList.sort((a, b) =>
            a.label.localeCompare(b.label),
          );
          setAllCoupleData(sort);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const getrolesList = async () => {
    await rolesApi
      .getAllRoleList()
      .then(async (res) => {
        let roles = [];
        res.data &&
          res.data.forEach((item) => {
            if (item.role) {
              roles.push({
                label: item.role,
                value: item.id,
              });
            }
          });
        const filteredRoles = roles.filter(
          (role) =>
            role.label === "Lead" ||
            role.label === "Co-Lead" ||
            // role.label === "Shadow Lead" ||
            role.label === "Spiritual Director" ||
            role.label === "Spiritual Mentor" ||
            role.label === "Mentor",
        );

        const roleOrder = [
          "Lead",
          "Co-Lead",
          // "Shadow Lead",
          "Mentor",
          "Spiritual Mentor",
          "Spiritual Director",
        ];

        const sortedRoles = filteredRoles.sort(
          (a, b) => roleOrder.indexOf(a.label) - roleOrder.indexOf(b.label),
        );
        setRolesDataList(sortedRoles);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const getTalksList = async () => {
    await talksApi
      .getAllTalkList()
      .then(async (res) => {
        let talks = [];
        res.data &&
          res.data.forEach((item) => {
            if (item.talk) {
              talks.push({
                label: item.talk,
                value: item.talkId,
              });
            }
          });
        const sort = talks.sort((a, b) => {
          const indexA = talkOrder.indexOf(a.label);
          const indexB = talkOrder.indexOf(b.label);
          if (indexA === -1 && indexB === -1)
            return a.label.localeCompare(b.label);
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
          return indexA - indexB;
        });
        setTalksDataList(sort);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const getServiceList = async () => {
    await serviceApi
      .getAllServiceList()
      .then(async (res) => {
        let services = [];
        res.data &&
          res.data.forEach((item) => {
            if (item.service) {
              services.push({
                label: item.service,
                value: item.id,
              });
            }
          });
        const sort = services.sort((a, b) => a.label.localeCompare(b.label));
        setServiceDataList(sort);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const getAllRoastersInfo = async (id) => {
    await programApi
      .getAllRoastersInfo({ rereatId: id })
      .then((response) => {
        const result = response.data;
        if (result && result[1] && result[1].speakers) {
          result[1].speakers.sort((a, b) => {
            const indexA = talkOrder.indexOf(a.talk);
            const indexB = talkOrder.indexOf(b.talk);
            if (indexA === -1 && indexB === -1)
              return a.talk.localeCompare(b.talk);
            if (indexA === -1) return 1;
            if (indexB === -1) return -1;
            return indexA - indexB;
          });
        }
        console.log("result--->",result);
        
        setRoasterData(result);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const getProgramDetail = async (id) => {
    await programApi
      .getProgramDetail({ rereatId: id })
      .then((response) => {
        const modifiedData = { ...response.data[0] };
        if (modifiedData.footerImages) {
          modifiedData.footerImages = JSON.parse(modifiedData.footerImages);
        }
        if (modifiedData.endingPageBgColor) {
          setEndingPageBgColor(modifiedData.endingPageBgColor);
        }
        setProgram(modifiedData);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const handleallProgramImages = (e, prog, imageSelection) => {
    setLoadData(true);
    let { name, value } = e.target;
    if (name === "imageUrl" && e.target.files && e.target.files.length > 0) {
      let allData = new FormData();
      allData.append("file", e.target.files[0]);
      allData.append("programId", prog && prog.id);
      allData.append("retreatId", id);
      allData.append("imageSelection", imageSelection);
      programApi
        .createProgram(allData)
        .then(async (res) => {

          toast.success(res.msg);
          getProgramDetail(id);
          setLoadData(false);
        })
        .catch((error) => {
          console.error(error);
          toast.error("An error occurred while uploading the image.");
        });
    } else {
      toast.error("Please select an image.");
    }
  };

  const hadleProgramModel = (a, item) => {
    setModalProramShow(true);
    setNameModel(a);
    setCoupleTalkData(item);
  };

  const openTalkWorksheet = (item, index) => {
    setWorksheetTalk({ item, index });
  };

  const closeProgramModel = async () => {
    await getAllRoastersInfo(id);
    await getProgramDetail(id);
    setModalProramShow(false);
  };

  const upload = (i) => {
    document.getElementById(`${i}` + "-" + "CoupleProfileUpload").click();
    setIsTempUpload(true);
  };

  const remove = (coupleDta, selection, checkImage) => {
    setIsTempUpload(false);
    programApi
      .removeProgramImage({ checkImage: checkImage, id: coupleDta.id })
      .then((res) => {
        toast.success(res.msg);
        getProgramDetail(coupleDta.retreatId);
      })
      .catch((error) => {
        console.error(error);
        toast.error("An error occurred while uploading the image.");
      });
  };

  const changePublishStatus = (select) => {
    programApi
      .changePublishStatus({
        select: select,
        retreatId: id,
        userData: JSON.stringify(userData),
      })
      .then((res) => {
        console.log("res--->", res);
        if (res.success) {
          getProgramDetail(id);
          toast.success(res.msg);
        } else {
          getProgramDetail(id);
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const updateEndingPageBgColor = async (color) => {
    try {
      const res = await programApi.updateEndingPageBgColor({
        retreatId: id,
        endingPageBgColor: color,
      });

      if (res.success) {
        setEndingPageBgColor(color);
        toast.success("Back Cover Page Color updated successfully");
        getProgramDetail(id); // Refresh program data
      } else {
        toast.error(res.msg || "Failed to update back cover page color");
      }
    } catch (error) {
      toast.error("Error updating back cover page color");
    }
  };

  const handleSelectOption = (val, selection) => {
    if (selection === "forRole") {
      setRoleSelect(val);
      const spiritual = val?.label === "Spiritual Director";
      setIsSpiritualDirector(spiritual);
      setCoupleSelectForRole(null);
      setPriestSelectForRole(null);
    } else if (selection === "forTalk") {
      setTalkSelect(val);
    } else if (selection === "coupleForRole") {
      setCoupleSelectForRole(val);
    } else if (selection === "priestForRole") {
      setPriestSelectForRole(val);
    } else if (selection === "coupleForTalk") {
      setCoupleSelectForTalk(val);
    } else if (selection === "forService") {
      setServiceSelect(val);
    } else if (selection === "coupleForService") {
      setCoupleSelectForService(val);
    }
  };

  const handleSelectSubmit = async (selection) => {
    let submitData = {};

    try {
      if (selection === "forRole") {
        if (!roleSelect?.value) {
          toast.error("Please select Role.");
          return;
        }

        if (isSpiritualDirector) {
          if (!priestSelectForRole?.value) {
            toast.error("Please select Priest.");
            return;
          }
        } else {
          if (!coupleSelectForRole?.value) {
            toast.error("Please select Couple.");
            return;
          }
        }

        submitData = {
          selection: "forRole",
          roleId: roleSelect.value,
          retreatId: id,
          coupleId: isSpiritualDirector ? null : coupleSelectForRole.value,
          priestId: isSpiritualDirector ? priestSelectForRole.value : null,
        };

        setRoleGreenTick(true);
      } else if (selection === "forTalk") {
        if (!talkSelect?.value) {
          toast.error("Please select Talk.");
          return;
        }

        if (!coupleSelectForTalk?.value) {
          toast.error("Please select Couple.");
          return;
        }
        let text =
          '<div style="margin: 10px 0;"><hr style="border: 1px solid black; margin: 18px 0;" /><hr style="border: 1px solid black; margin: 18px 0;" /><hr style="border: 1px solid black; margin: 18px 0;" /><hr style="border: 1px solid black; margin: 18px 0;" /><hr style="border: 1px solid black; margin: 18px 0;" /></div>';
        submitData = {
          selection: "forTalk",
          talkId: talkSelect.value,
          coupleId: coupleSelectForTalk.value,
          retreatId: id,
          text: text,
        };

        setTalkGreenTick(true);
      } else if (selection === "forService") {
        if (!serviceSelect?.value) {
          toast.error("Please select Service.");
          return;
        }

        if (!coupleSelectForService?.value) {
          toast.error("Please select Couple.");
          return;
        }

        submitData = {
          selection: "forService",
          serviceId: serviceSelect.value,
          coupleId: coupleSelectForService.value,
          retreatId: id,
        };

        setServiceGreenTick(true);
      }

      const res = await programApi.createRetreatTeam(submitData);

      if (res.success) {
        toast.success(res.msg);

        getAllRoastersInfo(id);
        getProgramDetail(id);
        getAllCouples();
        setRoleSelect(null);
        setCoupleSelectForRole(null);
        setPriestSelectForRole(null);
        setTalkSelect(null);
        setCoupleSelectForTalk(null);
        setServiceSelect(null);
        setCoupleSelectForService(null);
      } else {
        toast.error(res.msg);
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    }

    setTimeout(() => {
      setRoleGreenTick(false);
      setTalkGreenTick(false);
      setServiceGreenTick(false);
    }, 2000);
  };

  function deleteFooterFile(program, item) {
    programApi
      .removeProgramFooterImage({ id: program.id, item: item })
      .then((res) => {
        toast.success(res.msg);
        getProgramDetail(program.retreatId);
      })
      .catch((error) => {
        console.error(error);
        toast.error("An error occurred while uploading the image.");
      });
  }

  function deleteRoasterCouple() {
    programApi
      .deleteRoasterCouple({ id: deleteItm.id })
      .then((res) => {
        if (res.success) {
          toast.success(res.msg);
          getAllRoastersInfo(id);
          setShowDelete(false);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("An error occurred while uploading the image.");
      });
  }

  const handleShow = (item) => {
    setDeleteItm(item);
    setShowDelete(true);
  };

  const handleClose = () => {
    setShowDelete(false);
  };

  const pageMap = buildPageMap();

  // Renders "N / Total" at the bottom of each section.
  // Captured by html2canvas so it appears in the PDF too.
  // The jsPDF pdf.text() page number was removed from Program.jsx
  // to avoid double page numbers in the PDF.
  const PageNumber = ({ pageKey }) => {
    const pageNum = pageMap[pageKey];
    if (!pageNum) return null;
    return (
      <div
        className="html-page-number"
        style={{
          textAlign: "right",
          width: "100%",
          fontSize: "13px",
          color: "#888",
          padding: "8px 0 2px",
          letterSpacing: "0.5px",
        }}
      >
        {pageNum} / {pageMap["total"]}
      </div>
    );
  };

  const handleShare = () => {
    const publicLink = `${window.location.origin}/program/${id}`;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(publicLink)
        .then(() => {
          toast.success("Link copied successfully!");
        })
        .catch((err) => {
          toast.error("Failed to copy link");
        });
    } else {
      // Fallback
      const textArea = document.createElement("textarea");
      textArea.value = publicLink;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        toast.success("Link copied successfully!");
      } catch (err) {
        toast.error("Failed to copy link");
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <>
      <Link to="/manageRetreat" className="back-link">
        &lt;Back
      </Link>
      <div className="row ext-space create-program-page">
        <div className="col-lg-12 d-flex flex-column">
          <div className="row flex-grow">
            <div className="col-12 grid-margin stretch-card">
              <div className="card custom-card">
                <div className="card-body ">
                  <Container fluid className="create-retreat-header ">
                    <Row className="p-0">
                      <Col
                        xs={12}
                        sm={8}
                        md={8}
                        lg={8}
                        className="directorydata"
                      >
                        {" "}
                        <h1 className="addRetHeading">Program -</h1>
                        <div className="mt-2 program-upper-title">
                          <h6>
                            {data && data.title
                              ? `${
                                  data &&
                                  data.title &&
                                  data.title.charAt(0).toUpperCase() +
                                    data.title.slice(1)
                                }, `
                              : null}

                            {data.dateFrom && data.dateTo
                              ? moment(data.dateFrom).isSame(data.dateTo, "day")
                                ? `${moment(data.dateFrom)
                                    .tz("America/New_York")
                                    .format("MMM D, YYYY")}`
                                : moment(data.dateFrom).isSame(
                                      data.dateTo,
                                      "month",
                                    )
                                  ? `${moment(data.dateFrom)
                                      .tz("America/New_York")
                                      .format("MMM D")} - ${moment(data.dateTo)
                                      .tz("America/New_York")
                                      .format("D")}, ${moment(data.dateFrom)
                                      .tz("America/New_York")
                                      .format("YYYY")}`
                                  : `${moment(data.dateFrom)
                                      .tz("America/New_York")
                                      .format("MMM D")} - ${moment(data.dateTo)
                                      .tz("America/New_York")
                                      .format("MMM D")}, ${moment(data.dateFrom)
                                      .tz("America/New_York")
                                      .format("YYYY")}`
                              : null}
                          </h6>
                        </div>
                      </Col>
                      <Col xs={12} sm={4} md={4} lg={4} className="program-actions-col">
                        {" "}
                        <Button
                          onClick={() => changePublishStatus("program")}
                          className="btn-sm submitRet"
                        >
                          {program && program.status === "PUBLISH"
                            ? "Unpublish"
                            : "Publish"}
                        </Button>
                        <a
                          href={`/program/${id}`}
                          className="font-size"
                          target="_blank"
                        >
                          <Button
                            variant="primary"
                            className="btn-sm submitRet"
                          >
                            Preview
                          </Button>
                        </a>
                        <Button
                          variant="primary"
                          className="btn-sm submitRet copyDirProg d-flex align-items-center gap-2"
                          onClick={handleShare}
                          title={t("copy_program_link")}
                          style={{ marginLeft: "10px", border: "none" }}
                        >
                          <i className="mdi mdi-content-copy"></i>
                          Copy Program Link
                        </Button>
                      </Col>
                      <hr className="mb-0" />
                      <Col md={3} className="left-retreat-panel">
                        <div className="scrollable-content">
                          <div className="row">
                            <Col
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              className="col-12 text-center add-role-in-program"
                            >
                              <h5>Retreat Lead Team</h5>
                              <Row className="">
                                <Col
                                  md={8}
                                  lg={8}
                                  sm={8}
                                  xs={8}
                                  className="p-0"
                                >
                                  <Select
                                    className="mt-2 actions-couple add-service-buttons"
                                    id="roles"
                                    name="roles"
                                    options={rolesDataList}
                                    value={roleSelect}
                                    onChange={(val) => {
                                      handleSelectOption(val, "forRole");
                                    }}
                                    labelledBy="Roles"
                                    isSearchable={true}
                                    isMulti={false}
                                    placeholder={t("select_role")}
                                  />

                                  <Col md={5}>
                                    {isSpiritualDirector ? (
                                      <Select
                                        className="mt-3 actions-couple add-service-buttons"
                                        id="priest"
                                        name="priest"
                                        options={formattedPriestsList}
                                        value={priestSelectForRole}
                                        onChange={(val) =>
                                          handleSelectOption(
                                            val,
                                            "priestForRole",
                                          )
                                        }
                                        isSearchable
                                        placeholder={t("select_priest")}
                                        isMulti={false}
                                      />
                                    ) : (
                                      <Select
                                        className="mt-3 actions-couple add-service-buttons"
                                        id="couple"
                                        name="couple"
                                        options={allCoupleData}
                                        value={coupleSelectForRole}
                                        onChange={(val) =>
                                          handleSelectOption(
                                            val,
                                            "coupleForRole",
                                          )
                                        }
                                        isSearchable
                                        placeholder={t("select_couple")}
                                        isMulti={false}
                                      />
                                    )}
                                  </Col>
                                </Col>
                                {roleGreenTick ? (
                                  <Col
                                    md={4}
                                    lg={4}
                                    sm={4}
                                    xs={4}
                                    className="mb-2"
                                  >
                                    <div className="selctSubmit">
                                      <i
                                        type="button"
                                        className="mdi mdi-check btn-icon-prepend mt-0 mb-3 plus-icon-role greenTick"
                                      ></i>
                                    </div>
                                  </Col>
                                ) : (
                                  <Col
                                    md={4}
                                    lg={4}
                                    sm={4}
                                    xs={4}
                                    className="mb-2"
                                  >
                                    <div className="selctSubmit">
                                      {" "}
                                      <i
                                        type="button"
                                        onClick={() => {
                                          handleSelectSubmit("forRole");
                                        }}
                                        className="mdi mdi-plus-circle btn-icon-prepend mt-0 mb-3 plus-icon-role"
                                      ></i>
                                    </div>
                                  </Col>
                                )}
                              </Row>
                            </Col>
                            <hr className="mb-0" />
                            <Col
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              className="col-12 text-center add-role-in-program"
                            >
                              <h5>Speakers</h5>
                              <Row>
                                <Col
                                  md={8}
                                  lg={8}
                                  sm={8}
                                  xs={8}
                                  className="p-0 mb-2"
                                >
                                  <Select
                                    className="mt-2 actions-couple add-service-buttons"
                                    id="roles"
                                    name="roles"
                                    options={talksDataList.map((talk) => ({
                                      ...talk,
                                      isDisabled:
                                        roasterData?.[1]?.speakers?.some(
                                          (speaker) =>
                                            speaker.talk === talk.label ||
                                            speaker.talkId === talk.value,
                                        ),
                                    }))}
                                    value={talkSelect}
                                    onChange={(val) => {
                                      handleSelectOption(val, "forTalk");
                                    }}
                                    labelledBy="Roles"
                                    isSearchable={true}
                                    isMulti={false}
                                    placeholder={t("select_talk")}
                                  />
                                  <Select
                                    className="mt-3 actions-couple add-service-buttons"
                                    id="couple"
                                    name="couple"
                                    options={allCoupleData}
                                    value={coupleSelectForTalk}
                                    onChange={(val) => {
                                      handleSelectOption(val, "coupleForTalk");
                                    }}
                                    labelledBy="Select"
                                    isSearchable={true}
                                    isMulti={false}
                                    placeholder="Select Couple"
                                  />
                                </Col>

                                {talkGreenTick ? (
                                  <Col
                                    md={4}
                                    lg={4}
                                    sm={4}
                                    xs={4}
                                    className="mb-2"
                                  >
                                    <div className="selctSubmit">
                                      {" "}
                                      <i
                                        type="button"
                                        className="mdi mdi-check btn-icon-prepend mt-0 mb-3 plus-icon-role greenTick"
                                      ></i>
                                    </div>
                                  </Col>
                                ) : (
                                  <Col md={4} lg={4} sm={4} xs={4}>
                                    {" "}
                                    <div className="selctSubmit">
                                      {" "}
                                      <i
                                        type="button"
                                        onClick={() => {
                                          handleSelectSubmit("forTalk");
                                        }}
                                        className="mdi mdi-plus-circle btn-icon-prepend mt-0 mb-3 plus-icon-role"
                                      ></i>
                                    </div>
                                  </Col>
                                )}
                              </Row>
                            </Col>
                            <hr className="mb-0" />
                            <Col
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              className="col-12 text-center add-role-in-program"
                            >
                              <h5>Support Teams</h5>

                              <Row>
                                <Col
                                  md={8}
                                  lg={8}
                                  sm={8}
                                  xs={8}
                                  className="p-0 mb-2"
                                >
                                  <Select
                                    className="mt-2 actions-couple add-service-buttons"
                                    id="service"
                                    name="service"
                                    options={serviceDataList}
                                    value={serviceSelect}
                                    onChange={(val) => {
                                      handleSelectOption(val, "forService");
                                    }}
                                    labelledBy="Service"
                                    isSearchable={true}
                                    isMulti={false}
                                    placeholder={t("select_service")}
                                  />
                                  <Select
                                    className="mt-3 actions-couple add-service-buttons"
                                    id="couple"
                                    name="couple"
                                    options={allCoupleData}
                                    value={coupleSelectForService}
                                    onChange={(val) => {
                                      handleSelectOption(
                                        val,
                                        "coupleForService",
                                      );
                                    }}
                                    labelledBy="Select"
                                    isSearchable={true}
                                    isMulti={false}
                                    placeholder="Select Couple"
                                  />
                                </Col>
                                {serviceGreenTick ? (
                                  <Col
                                    md={4}
                                    lg={4}
                                    sm={4}
                                    xs={4}
                                    className="mb-2"
                                  >
                                    <div className="selctSubmit">
                                      {" "}
                                      <i
                                        type="button"
                                        className="mdi mdi-check btn-icon-prepend mt-0 mb-3 plus-icon-role greenTick"
                                      ></i>
                                    </div>
                                  </Col>
                                ) : (
                                  <Col md={4} lg={4} sm={4} xs={4}>
                                    <div className="selctSubmit">
                                      {" "}
                                      <i
                                        type="button"
                                        onClick={() => {
                                          handleSelectSubmit("forService");
                                        }}
                                        className="mdi mdi-plus-circle btn-icon-prepend mt-0 mb-3 plus-icon-role"
                                      ></i>
                                    </div>
                                  </Col>
                                )}
                              </Row>
                            </Col>
                            <hr className="mb-0" />
                            <Col
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              className="text-center sideProgram"
                            >
                              <Row>
                                <Col
                                  lg={9}
                                  md={9}
                                  sm={9}
                                  xs={9}
                                  className="set-text-heading"
                                >
                                  {" "}
                                  <h5>{t("opening_prayer")}</h5>
                                </Col>
                                <Col
                                  lg={3}
                                  md={3}
                                  sm={3}
                                  xs={3}
                                  className="sideFields"
                                >
                                  {" "}
                                  <button
                                    className="font-size"
                                    onClick={() =>
                                      hadleProgramModel("openingPrayer")
                                    }
                                  >
                                    <i
                                      className="mdi mdi-pencil-box text-lg font-size uploadMdi"
                                      title={t("edit")}
                                    ></i>
                                  </button>
                                </Col>
                              </Row>
                            </Col>
                            <hr className="mb-0" />
                            <Col
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              className="text-center sideProgram"
                            >
                              <Row>
                                <Col
                                  lg={9}
                                  md={9}
                                  sm={9}
                                  xs={9}
                                  className="set-text-heading"
                                >
                                  {" "}
                                  <h5>{t("wisdom_from_mother_theresa")}</h5>
                                </Col>
                                <Col
                                  lg={3}
                                  md={3}
                                  sm={3}
                                  xs={3}
                                  className="sideFields"
                                >
                                  {" "}
                                  <button
                                    className="font-size"
                                    onClick={() =>
                                      hadleProgramModel("WisdomDescription")
                                    }
                                  >
                                    <i
                                      className="mdi mdi-pencil-box text-lg font-size uploadMdi"
                                      title={t("edit")}
                                    ></i>
                                  </button>
                                </Col>
                              </Row>
                            </Col>
                            <hr className="mb-0" />
                            <Col
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              className="text-center sideProgram"
                            >
                              <Row>
                                <Col
                                  lg={9}
                                  md={9}
                                  sm={9}
                                  xs={9}
                                  className="set-text-heading"
                                >
                                  {" "}
                                  <h5>{t("add_guidelines")}</h5>
                                </Col>
                                <Col
                                  lg={3}
                                  md={3}
                                  sm={3}
                                  xs={3}
                                  className="sideFields"
                                >
                                  {" "}
                                  <button
                                    className="font-size"
                                    onClick={() =>
                                      hadleProgramModel("guidelines")
                                    }
                                  >
                                    <i
                                      className="mdi mdi-pencil-box text-lg font-size uploadMdi"
                                      title={t("edit")}
                                    ></i>
                                  </button>
                                </Col>
                              </Row>
                            </Col>
                            <hr className="mb-0" />
                            <Col
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              className="col-12 text-center mt-3 "
                            >
                              {roasterData &&
                              roasterData[1] &&
                              roasterData[1].speakers.length ? (
                                <h4 className="talk-question">
                                  {t("talks_questions")}
                                </h4>
                              ) : null}
                              {roasterData &&
                                roasterData[1] &&
                                roasterData[1].speakers &&
                                roasterData[1].speakers.map((item, i) => {
                                  return (
                                    <Row key={item.id || i}>
                                      {" "}
                                      <Col
                                        lg={10}
                                        md={10}
                                        sm={10}
                                        xs={10}
                                        className="text-center"
                                      >
                                        <div
                                          className="speakersQuestions item-talk mt-4"
                                          style={{
                                            backgroundColor:
                                              endingPageBgColor || "#1f4e7a",
                                          }}
                                          onClick={() =>
                                            openTalkWorksheet(item, i)
                                          }
                                        >
                                          <h5>{item.talk}</h5>
                                          <h5>{speakerDisplayName(item)}</h5>
                                        </div>
                                      </Col>
                                      <Col
                                        lg={2}
                                        md={2}
                                        sm={2}
                                        xs={2}
                                        className="text-center mt-5 p-0 sideFields"
                                      >
                                        <button
                                          type="button"
                                          className="font-size"
                                          onClick={() =>
                                            openTalkWorksheet(item, i)
                                          }
                                        >
                                          <i
                                            className="mdi mdi-pencil-box text-lg font-size"
                                            title={t("talk_questions")}
                                          ></i>
                                        </button>
                                      </Col>
                                    </Row>
                                  );
                                })}
                              {roasterData &&
                              roasterData[1] &&
                              roasterData[1].speakers.length ? (
                                <div className="mb-3"></div>
                              ) : null}
                            </Col>
                            {roasterData &&
                            roasterData[1] &&
                            roasterData[1].speakers.length ? (
                              <hr className="mb-0" />
                            ) : (
                              <div className="mb-0" />
                            )}
                            <Col
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              className="col-12 text-center sideProgram"
                            >
                              <Row>
                                <Col
                                  lg={9}
                                  md={9}
                                  sm={9}
                                  xs={9}
                                  className="set-text-heading"
                                >
                                  {" "}
                                  <h5>{t("parish_mission")}</h5>
                                </Col>
                                <Col
                                  lg={3}
                                  md={3}
                                  sm={3}
                                  xs={3}
                                  className="sideFields"
                                >
                                  {" "}
                                  <button
                                    className="font-size"
                                    onClick={() =>
                                      hadleProgramModel("ParishMission")
                                    }
                                  >
                                    <i
                                      className="mdi mdi-pencil-box text-lg font-size uploadMdi"
                                      title={t("edit")}
                                    ></i>
                                  </button>
                                </Col>
                              </Row>
                            </Col>
                            <hr className="mb-0" />
                            <Col
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              className="col-12 text-center  sideProgram"
                            >
                              <Row>
                                <Col
                                  lg={9}
                                  md={9}
                                  sm={9}
                                  xs={9}
                                  className="set-text-heading"
                                >
                                  <h5>{t("facebook_link")}</h5>
                                </Col>
                                <Col
                                  lg={3}
                                  md={3}
                                  sm={3}
                                  xs={3}
                                  className="sideFields"
                                >
                                  {" "}
                                  <button
                                    className="font-size"
                                    onClick={() => hadleProgramModel("fbLink")}
                                  >
                                    <i
                                      className="mdi mdi-pencil-box text-lg font-size uploadMdi"
                                      title={t("edit")}
                                    ></i>
                                  </button>
                                </Col>
                              </Row>
                            </Col>

                            <hr className="mb-0" />
                            <Col
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              className="col-12 text-center  sideProgram"
                            >
                              <Row>
                                <Col
                                  lg={9}
                                  md={9}
                                  sm={9}
                                  xs={9}
                                  className="set-text-heading"
                                >
                                  <h5>{t("instagram_link")}</h5>
                                </Col>
                                <Col
                                  lg={3}
                                  md={3}
                                  sm={3}
                                  xs={3}
                                  className="sideFields"
                                >
                                  {" "}
                                  <button
                                    className="font-size"
                                    onClick={() =>
                                      hadleProgramModel("instaLink")
                                    }
                                  >
                                    <i
                                      className="mdi mdi-pencil-box text-lg font-size uploadMdi"
                                      title={t("edit")}
                                    ></i>
                                  </button>
                                </Col>
                              </Row>
                            </Col>
                            <hr className="mb-0" />
                            <Col
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              className="col-12 text-center sideProgram"
                            >
                              {!program ||
                              program.qrCodeImage == "" ||
                              program.qrCodeImage == undefined ? (
                                <Row>
                                  <Col
                                    lg={9}
                                    md={9}
                                    sm={9}
                                    xs={9}
                                    className="set-text-heading"
                                  >
                                    {" "}
                                    <input
                                      name="imageUrl"
                                      className="pt-1"
                                      type="file"
                                      accept="image/*"
                                      style={{ display: "none" }}
                                      id={
                                        `${program.id}` +
                                        90 +
                                        "-" +
                                        "CoupleProfileUpload"
                                      }
                                      onChange={(e) =>
                                        handleallProgramImages(
                                          e,
                                          program,
                                          "qrCodeImage",
                                        )
                                      }
                                    />
                                    <h5>{t("qr_code")}</h5>
                                  </Col>
                                  <Col lg={3} md={3} sm={3} xs={3}>
                                    {" "}
                                    <i
                                      onClick={(e) => {
                                        upload(`${program.id}` + 90);
                                      }}
                                      className="mdi mdi-upload text-lg font-size uploadMdi1"
                                      title={t("image_upload")}
                                    ></i>
                                  </Col>
                                </Row>
                              ) : (
                                <Row>
                                  {" "}
                                  <Col
                                    lg={9}
                                    md={9}
                                    sm={9}
                                    xs={9}
                                    className="set-text-heading"
                                  >
                                    <h5>QR Code</h5>{" "}
                                  </Col>
                                  <Col lg={3} md={3} sm={3} xs={3}>
                                    {" "}
                                    <i
                                      className="mdi mdi-delete-circle text-md font-size uploadMdi"
                                      onClick={(e) => {
                                        remove(
                                          program,
                                          "program",
                                          "qrCodeImage",
                                        );
                                      }}
                                      title={t("remove")}
                                    ></i>
                                  </Col>{" "}
                                </Row>
                              )}
                            </Col>
                            <hr className="mb-0" />
                            <Col
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              className="col-12 text-center sideProgram"
                            >
                              <Row>
                                <Col
                                  lg={9}
                                  md={9}
                                  sm={9}
                                  xs={9}
                                  className="set-text-heading"
                                >
                                  {" "}
                                  <h5>{t("marriage_prayer_of_protection")}</h5>
                                </Col>
                                <Col
                                  lg={3}
                                  md={3}
                                  sm={3}
                                  xs={3}
                                  className="sideFields"
                                >
                                  {" "}
                                  <button
                                    className="font-size"
                                    onClick={() =>
                                      hadleProgramModel("prayerOfProtection")
                                    }
                                  >
                                    <i
                                      className="mdi mdi-pencil-box text-lg font-size uploadMdi"
                                      title={t("edit")}
                                    ></i>
                                  </button>
                                </Col>
                              </Row>
                            </Col>
                            <hr className="mb-0" />
                            <Col
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              className="col-12 text-center sideProgram"
                            >
                              <Row>
                                <Col
                                  lg={9}
                                  md={9}
                                  sm={9}
                                  xs={9}
                                  className="set-text-heading"
                                >
                                  {" "}
                                  <h5>{t("donations")}</h5>
                                </Col>
                                <Col
                                  lg={3}
                                  md={3}
                                  sm={3}
                                  xs={3}
                                  className="sideFields"
                                >
                                  {" "}
                                  <button
                                    className="font-size"
                                    onClick={() =>
                                      hadleProgramModel("donations")
                                    }
                                  >
                                    <i
                                      className="mdi mdi-pencil-box text-lg font-size uploadMdi"
                                      title={t("edit")}
                                    ></i>
                                  </button>
                                </Col>
                              </Row>
                            </Col>
                            <hr className="mb-0" />
                            <Col
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              onChange={(e) =>
                                handleallProgramImages(
                                  e,
                                  program,
                                  "footerImages",
                                )
                              }
                              className="col-12 text-center sideProgram "
                            >
                              <Row>
                                <Col
                                  lg={9}
                                  md={9}
                                  sm={9}
                                  xs={9}
                                  className="set-text-heading"
                                >
                                  {" "}
                                  <input
                                    name="imageUrl"
                                    className="pt-1"
                                    type="file"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    id={
                                      `${program.id}` +
                                      101 +
                                      "-" +
                                      "CoupleProfileUpload"
                                    }
                                  />
                                  <h5>{t("upload_footer_images")}</h5>
                                </Col>
                                <Col lg={3} md={3} sm={3} xs={3}>
                                  {" "}
                                  <i
                                    onClick={(e) => {
                                      upload(`${program.id}` + 101);
                                    }}
                                    className="mdi mdi-upload text-lg font-size uploadMdi1"
                                    title="Image Upload"
                                  ></i>
                                </Col>
                              </Row>
                            </Col>

                            <hr className="mb-0" />
                            <Col
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              className="col-12 text-center  sideProgram"
                            >
                              <Row>
                                <Col
                                  lg={9}
                                  md={9}
                                  sm={9}
                                  xs={9}
                                  className="set-text-heading"
                                >
                                  <h5>{t("back_cover_page_color")}</h5>
                                </Col>
                                <Col
                                  lg={3}
                                  md={3}
                                  sm={3}
                                  xs={3}
                                  className="sideFields"
                                >
                                  {" "}
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                    }}
                                  >
                                    <input
                                      type="color"
                                      value={endingPageBgColor}
                                      onChange={(e) => {
                                        const next = e.target.value;
                                        if (next === endingPageBgColor) return;
                                        setTempColor(next);
                                        setShowColorAlert(true);
                                      }}
                                      style={{
                                        width: "50px",
                                        height: "35px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                      }}
                                      title={t("choose_back_cover_page_color")}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        </div>
                      </Col>
                      <Col md={9} className="right-retreat-panel p-0">
                        <div className="scrollable-content">
                          <div className="container-scroller mainpannel">
                            <div className="container-fluid page-body-wrapper full-page-wrapper">
                              <div className="row w-100 mx-0">
                                {LoadData ? (
                                  <div className="auth-form-light text-center main-register py-5 pt-0 px-4 px-sm-5 program-preview-content">
                                    <Row className="text-center">
                                      <Col
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        className="colorTalks mt-3 p-5"
                                      >
                                        <Loader />
                                      </Col>
                                    </Row>
                                  </div>
                                ) : (
                                  <div className="auth-form-light main-register py-5 pt-0 px-4 px-sm-4 program-preview-content">
                                    <Row>
                                      {/* ── PAGE 1: COVER ── */}
                                      <Col
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        className="colorTalks text-center mt-3"
                                      >
                                        <img
                                          src={lovestrongLogo}
                                          alt=""
                                          srcset=""
                                          className="program_logo"
                                        />
                                        <h4
                                          style={{
                                            color: "#d2b74c",
                                            fontWeight: "700",
                                          }}
                                        >
                                          {tp("ministry")}
                                        </h4>
                                        <h4 className="mt-3 mb-3">
                                          <em
                                            style={{
                                              color: "#d2b74c",
                                              fontWeight: "700",
                                            }}
                                          >
                                            {tp("live_love_strong")}
                                          </em>
                                        </h4>
                                        <Col lg={12} md={12} sm={12} xs={12}>
                                          <div className="mt-3 howerOption mainHeaderImage">
                                            <div>
                                              {data.image1 ? (
                                                <img
                                                  src={data.image1}
                                                  className="imageHeader"
                                                  onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src =
                                                      ImagePlaceHolder;
                                                  }}
                                                />
                                              ) : (
                                                <img
                                                  src={ImagePlaceHolder}
                                                  className="imageHeader"
                                                />
                                              )}
                                            </div>
                                          </div>
                                        </Col>
                                        <Col
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                          className="directoryHeader1 m-0 mb-5"
                                        >
                                          <div
                                            style={{
                                              backgroundColor:
                                                endingPageBgColor || "#1f4e7a",
                                            }}
                                          >
                                            <p>{tp("retreat_program")}</p>
                                            <h2>
                                              {" "}
                                              {isSpanish
                                                ? data?.myparish
                                                    ?.spanishParish ||
                                                  data?.myparish?.parish
                                                : data?.myparish?.parish}
                                            </h2>
                                            <h1 className="mt-2 m-0">
                                              {data.dateFrom && data.dateTo ? (
                                                <span>
                                                  {moment(data.dateFrom).isSame(
                                                    data.dateTo,
                                                    "day",
                                                  )
                                                    ? `${moment(data.dateFrom)
                                                        .tz("America/New_York")
                                                        .format("MMM D, YYYY")}`
                                                    : moment(
                                                          data.dateFrom,
                                                        ).isSame(
                                                          data.dateTo,
                                                          "month",
                                                        )
                                                      ? `${moment(data.dateFrom)
                                                          .tz(
                                                            "America/New_York",
                                                          )
                                                          .format(
                                                            "MMM D",
                                                          )} - ${moment(
                                                          data.dateTo,
                                                        )
                                                          .tz(
                                                            "America/New_York",
                                                          )
                                                          .format(
                                                            "D",
                                                          )}, ${moment(
                                                          data.dateFrom,
                                                        )
                                                          .tz(
                                                            "America/New_York",
                                                          )
                                                          .format("YYYY")}`
                                                      : `${moment(data.dateFrom)
                                                          .tz(
                                                            "America/New_York",
                                                          )
                                                          .format(
                                                            "MMM D",
                                                          )} - ${moment(
                                                          data.dateTo,
                                                        )
                                                          .tz(
                                                            "America/New_York",
                                                          )
                                                          .format(
                                                            "MMM D",
                                                          )}, ${moment(
                                                          data.dateFrom,
                                                        )
                                                          .tz(
                                                            "America/New_York",
                                                          )
                                                          .format("YYYY")}`}
                                                </span>
                                              ) : null}
                                            </h1>
                                          </div>
                                        </Col>
                                        <PageNumber pageKey="cover" />
                                      </Col>

                                      {/* ── PAGE 2: TABLE OF CONTENTS ── */}
                                      <Col
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        className="colorTalks mt-3"
                                      >
                                        <div className="program-toc-content">
                                          <h3 className="program-toc-title">
                                            {tp("table_of_contents")}
                                          </h3>
                                          {(() => {
                                            const entries = [];
                                            let p = 3;

                                            entries.push({
                                              label: tp("opening_prayer"),
                                              page: p++,
                                              id: "section-openingPrayer",
                                            });

                                            if (
                                              roasterData?.[0]?.role?.length > 0
                                            )
                                              entries.push({
                                                label: tp("retreat_lead_team"),
                                                page: p++,
                                                id: "section-retreatTeam",
                                              });

                                            if (
                                              roasterData?.[1]?.speakers
                                                ?.length > 0
                                            )
                                              entries.push({
                                                label: tp("speakers"),
                                                page: p++,
                                                id: "section-speakersTeam",
                                              });

                                            if (
                                              roasterData?.[2]?.services
                                                ?.length > 0
                                            )
                                              entries.push({
                                                label: tp("support_teams"),
                                                page: p++,
                                                id: "section-supportTeams",
                                              });

                                            if (program?.wisdom_from_mt)
                                              entries.push({
                                                label: tp(
                                                  "wisdom_from_mother_theresa",
                                                ),
                                                page: p++,
                                                id: "section-wisdom",
                                              });

                                            if (program?.guidelines)
                                              entries.push({
                                                label: tp(
                                                  "guidelines_sharing_table_discussion",
                                                ),
                                                page: p++,
                                                id: "section-guidelines",
                                              });

                                            const speakers =
                                              roasterData?.[1]?.speakers || [];
                                            speakers.forEach((item, i) => {
                                              const talkLabel = isSpanish
                                                ? item.spanishTalk || item.talk
                                                : item.talk;
                                              entries.push({
                                                label: `${tp("talk")} ${i + 1}: ${talkLabel}`,
                                                page: p++,
                                                id: `section-talk_${i}`,
                                              });
                                            });

                                            entries.push({
                                              label: tp("parish_mission"),
                                              page: p++,
                                              id: "section-parishMission",
                                            });

                                            entries.push({
                                              label: tp(
                                                "marriage_prayer_of_protection",
                                              ),
                                              page: p++,
                                              id: "section-prayerOfProtection",
                                            });

                                            entries.push({
                                              label: tp("donations"),
                                              page: p++,
                                              id: "section-donations",
                                            });

                                            if (
                                              program?.footerImages?.length > 0
                                            ) {
                                              program.footerImages.forEach(
                                                (_, idx) => {
                                                  if (idx === 0) {
                                                    entries.push({
                                                      label:
                                                        tp("footer_images"),
                                                      page: p++,
                                                      id: `section-footer_${idx}`,
                                                    });
                                                  } else {
                                                    entries.push({
                                                      label: `${tp("footer_images")} ${idx + 1}`,
                                                      page: p++,
                                                      id: `section-footer_${idx}`,
                                                    });
                                                  }
                                                },
                                              );
                                            }

                                            entries.push({
                                              label: tp("back_cover_page"),
                                              page: p++,
                                              id: "section-endingPage",
                                            });

                                            const handleScroll = (id) => {
                                              const element =
                                                document.getElementById(id);
                                              if (element) {
                                                element.scrollIntoView({
                                                  behavior: "smooth",
                                                  block: "start",
                                                });
                                              }
                                            };

                                            return entries.map(
                                              (entry, index) => (
                                                <Row
                                                  key={index}
                                                  style={{
                                                    marginBottom: "15px",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() => {
                                                    handleScroll(entry.id);
                                                  }}
                                                  className="toc-entry"
                                                >
                                                  <Col
                                                    xs={8}
                                                    style={{
                                                      color: "#007bff",
                                                      fontWeight: "500",
                                                    }}
                                                  >
                                                    {entry.label}
                                                  </Col>
                                                  <Col
                                                    xs={4}
                                                    style={{
                                                      color: "#007bff",
                                                      textAlign: "right",
                                                    }}
                                                  >
                                                    {tp("page")} {entry.page}
                                                  </Col>
                                                </Row>
                                              ),
                                            );
                                          })()}
                                        </div>
                                        <PageNumber pageKey="toc" />
                                      </Col>

                                      {/* ── PAGE 3: OPENING PRAYER ── */}
                                      <Col
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        id="section-openingPrayer"
                                        className="colorTalks mt-3 text-center"
                                      >
                                        <div
                                          style={{
                                            marginBottom: "15px",
                                            marginTop: "30px",
                                          }}
                                        >
                                          {" "}
                                          {program?.openingPrayer ? (
                                            <div
                                              style={{ textAlign: "center" }}
                                              dangerouslySetInnerHTML={{
                                                __html: program?.openingPrayer,
                                              }}
                                            ></div>
                                          ) : (
                                            <div
                                              style={{ textAlign: "center" }}
                                              dangerouslySetInnerHTML={{
                                                __html: tp(
                                                  "opening_prayer_content",
                                                ),
                                              }}
                                            ></div>
                                          )}
                                        </div>

                                        <img
                                          src={lovestrongLogo}
                                          alt=""
                                          className="program_logo mt-3"
                                        />
                                        <h5 className="mt-2 mb-5">
                                          <em
                                            style={{
                                              color: "#d2b74c",
                                              fontWeight: "700",
                                            }}
                                          >
                                            {tp("live_love_strong")}
                                          </em>
                                        </h5>
                                        <PageNumber pageKey="openingPrayer" />
                                      </Col>

                                      {(roasterData &&
                                        roasterData[0] &&
                                        roasterData[0].role &&
                                        roasterData[0].role.length) ||
                                      (roasterData &&
                                        roasterData[1] &&
                                        roasterData[1].speakers &&
                                        roasterData[1].speakers.length) ||
                                      (roasterData &&
                                        roasterData[2] &&
                                        roasterData[2].services.length) ? (
                                        <Col
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                          id="section-retreatTeam"
                                          className="colorTalks roaster_list pt-0 mt-3 text-center"
                                          style={{
                                            backgroundColor: "rgb(234 232 232)",
                                            backgroundSize: "cover",
                                            backgroundPosition: "center",
                                          }}
                                        >
                                          <Container className="table_Content_Data">
                                            {roasterData &&
                                            roasterData[0] &&
                                            roasterData[0].role &&
                                            roasterData[0].role.length ? (
                                              <h3 className="mt-5 mb-4">
                                                {tp("retreat_lead_team")}
                                              </h3>
                                            ) : null}
                                            {roasterData &&
                                              roasterData[0] &&
                                              roasterData[0].role &&
                                              roasterData[0].role
                                                .filter((item) =>
                                                  [
                                                    "Spiritual Director",
                                                    "Lead",
                                                    "Co-Lead",
                                                    "Mentor",
                                                    "Spiritual Mentor",
                                                  ].includes(item.role),
                                                )
                                                .sort(
                                                  (a, b) =>
                                                    [
                                                      "Spiritual Director",
                                                      "Lead",
                                                      "Co-Lead",
                                                      "Mentor",
                                                      "Spiritual Mentor",
                                                    ].indexOf(a.role) -
                                                    [
                                                      "Spiritual Director",
                                                      "Lead",
                                                      "Co-Lead",
                                                      "Mentor",
                                                      "Spiritual Mentor",
                                                    ].indexOf(b.role),
                                                )
                                                .map((item, i) => {
                                                  return (
                                                    <Row
                                                      key={i}
                                                      className="table_content mt-1"
                                                    >
                                                      <Col
                                                        lg={5}
                                                        md={5}
                                                        sm={5}
                                                        xs={5}
                                                        className="mt-3 master-couple"
                                                      >
                                                      <h3>
  {item.role === "Spiritual Director"
    ? tp("spiritual_director")
    : item.role === "Spiritual Mentor"
      ? item?.hisFirstName && item?.herFirstName
        ? tp("spiritual_mentor_couple")
        : tp("spiritual_mentor")
      : isSpanish
        ? `${tp("couple_suffix")} ${
            item.spanishRole || item.role
          }`
        : `${item.role}${tp("couple_suffix")}`}
</h3>
                                                      </Col>

                                                      <Col
                                                        lg={5}
                                                        md={5}
                                                        sm={5}
                                                        xs={5}
                                                        className="mt-3 master-couple"
                                                      >
                                                        {item.role ===
                                                        "Spiritual Director" ? (
                                                          <h3>
                                                            {`${item?.title ? `${item.title} ` : ""}${item?.firstName || ""} ${item?.lastName || ""}`}
                                                          </h3>
                                                        ) : item.role ===
                                                          "Spiritual Mentor" ? (
                                                          <h3>
                                                            {item?.hisFirstName &&
                                                            item?.herFirstName
                                                              ? `${item.hisFirstName} & ${item.herFirstName} ${item.hisLastName || ""}`
                                                              : item?.hisFirstName
                                                                ? `${item.hisFirstName} ${item.hisLastName || ""}`
                                                                : item?.herFirstName
                                                                  ? `${item.herFirstName} ${item.herLastName || ""}`
                                                                  : ""}
                                                          </h3>
                                                        ) : (
                                                          <h3>
                                                            {`${item?.hisFirstName || ""}${
                                                              item?.hisFirstName &&
                                                              item?.herFirstName
                                                                ? " & "
                                                                : ""
                                                            }${item?.herFirstName || ""} ${
                                                              item?.hisLastName ||
                                                              item?.herLastName ||
                                                              ""
                                                            }`}
                                                          </h3>
                                                        )}
                                                      </Col>

                                                      <Col
                                                        lg={2}
                                                        md={2}
                                                        sm={2}
                                                        xs={2}
                                                        className="mt-2"
                                                      >
                                                        <button
                                                          onClick={() =>
                                                            handleShow(item)
                                                          }
                                                          className="font-size delete-icon"
                                                        >
                                                          <i
                                                            className="mdi mdi-delete-forever text-md mx-2 font-size"
                                                            title={t("delete")}
                                                          ></i>
                                                        </button>
                                                      </Col>
                                                    </Row>
                                                  );
                                                })}
                                            <PageNumber pageKey="retreatLeadTeam" />
                                            {roasterData &&
                                            roasterData[1] &&
                                            roasterData[1].speakers &&
                                            roasterData[1].speakers.length ? (
                                              <>
                                                {" "}
                                                <hr />{" "}
                                                <h3
                                                  id="section-speakersTeam"
                                                  className="mt-5 mb-3"
                                                >
                                                  {tp("speakers")}
                                                </h3>
                                              </>
                                            ) : null}
                                            {roasterData &&
                                              roasterData[1] &&
                                              roasterData[1].speakers &&
                                              roasterData[1].speakers.map(
                                                (item, i) => {
                                                  return (
                                                    <Row
                                                      key={i}
                                                      className="table_content mt-1"
                                                    >
                                                      <Col
                                                        lg={5}
                                                        md={5}
                                                        sm={5}
                                                        xs={5}
                                                        className="mt-3 master-couple"
                                                      >
                                                        <h3>
                                                          {tp("talk")} {i + 1}:{" "}
                                                          {isSpanish
                                                            ? item.spanishTalk ||
                                                              item.talk
                                                            : item.talk}
                                                        </h3>
                                                      </Col>

                                                      <Col
                                                        lg={5}
                                                        md={5}
                                                        sm={5}
                                                        xs={5}
                                                        className="mt-3 master-couple"
                                                      >
                                                        {item.role ===
                                                        "Spiritual Director" ? (
                                                          <h3>
                                                            {`${item?.title ? `${item.title} ` : ""}${item?.firstName || ""} ${item?.lastName || ""}`}
                                                          </h3>
                                                        ) : item.role ===
                                                          "Spiritual Mentor" ? (
                                                          <h3>
                                                            {item?.hisFirstName &&
                                                            item?.herFirstName
                                                              ? `${item.hisFirstName} & ${item.herFirstName} ${item.hisLastName || ""}`
                                                              : item?.hisFirstName
                                                                ? `${item.hisFirstName} ${item.hisLastName || ""}`
                                                                : item?.herFirstName
                                                                  ? `${item.herFirstName} ${item.herLastName || ""}`
                                                                  : ""}
                                                          </h3>
                                                        ) : (
                                                          <h3>
                                                            {`${item?.hisFirstName || ""}${
                                                              item?.hisFirstName &&
                                                              item?.herFirstName
                                                                ? " & "
                                                                : ""
                                                            }${item?.herFirstName || ""} ${
                                                              item?.hisLastName ||
                                                              item?.herLastName ||
                                                              ""
                                                            }`}
                                                          </h3>
                                                        )}
                                                      </Col>

                                                      <Col
                                                        lg={2}
                                                        md={2}
                                                        sm={2}
                                                        xs={2}
                                                        className="mt-2"
                                                      >
                                                        <button
                                                          onClick={() =>
                                                            handleShow(item)
                                                          }
                                                          className="font-size delete-icon"
                                                        >
                                                          <i
                                                            className="mdi mdi-delete-forever text-md mx-2 font-size"
                                                            title={t("delete")}
                                                          ></i>
                                                        </button>
                                                      </Col>
                                                    </Row>
                                                  );
                                                },
                                              )}
                                            <PageNumber pageKey="speakersTeam" />
                                            {roasterData &&
                                            roasterData[2] &&
                                            roasterData[2].services.length ? (
                                              <>
                                                {" "}
                                                <hr />
                                                <h3
                                                  id="section-supportTeams"
                                                  className="mt-5 mb-3"
                                                >
                                                  {tp("support_teams")}
                                                </h3>
                                              </>
                                            ) : null}
                                            {roasterData &&
                                              roasterData[2] &&
                                              roasterData[2].services &&
                                              (() => {
                                                const groupedServices = {};

                                                // Group by service
                                                roasterData[2].services.forEach(
                                                  (item) => {
                                                    if (
                                                      !groupedServices[
                                                        item.service
                                                      ]
                                                    ) {
                                                      groupedServices[
                                                        item.service
                                                      ] = [];
                                                    }
                                                    groupedServices[
                                                      item.service
                                                    ].push(item);
                                                  },
                                                );

                                                return Object.keys(
                                                  groupedServices,
                                                ).map((serviceName, index) => {
                                                  return (
                                                    <React.Fragment key={index}>
                                                      {/* SERVICE NAME */}
                                                      <h3 className="mt-4 mb-2 serviceTerms">
                                                        {isSpanish
                                                          ? groupedServices[
                                                              serviceName
                                                            ][0]
                                                              .spanishService ||
                                                            serviceName
                                                          : serviceName}
                                                      </h3>

                                                      {groupedServices[
                                                        serviceName
                                                      ]
                                                        .slice()
                                                        .sort((a, b) => {
                                                          const roleOrder = [
                                                            "spiritual director",
                                                            "lead",
                                                            "co-lead",
                                                            "mentor",
                                                            "spiritual mentor",
                                                            "head",
                                                            "co-head",
                                                          ];

                                                          const normalizeRole =
                                                            (role) =>
                                                              role
                                                                ?.toLowerCase()
                                                                .replace(
                                                                  /\s+/g,
                                                                  "-",
                                                                );

                                                          const getPriority = (
                                                            role,
                                                          ) => {
                                                            if (!role)
                                                              return 999;
                                                            const index =
                                                              roleOrder.indexOf(
                                                                normalizeRole(
                                                                  role,
                                                                ),
                                                              );
                                                            return index !== -1
                                                              ? index
                                                              : 998;
                                                          };

                                                          const priorityA =
                                                            getPriority(a.role);
                                                          const priorityB =
                                                            getPriority(b.role);

                                                          if (
                                                            priorityA !==
                                                            priorityB
                                                          ) {
                                                            return (
                                                              priorityA -
                                                              priorityB
                                                            );
                                                          }

                                                          const lastNameA = (
                                                            a.hisLastName ||
                                                            a.herLastName ||
                                                            a.lastName ||
                                                            ""
                                                          ).toLowerCase();

                                                          const lastNameB = (
                                                            b.hisLastName ||
                                                            b.herLastName ||
                                                            b.lastName ||
                                                            ""
                                                          ).toLowerCase();

                                                          return lastNameA.localeCompare(
                                                            lastNameB,
                                                          );
                                                        })
                                                        .map((item, i) => {
                                                          const isBothPresent =
                                                            item?.hisFirstName &&
                                                            item?.herFirstName;

                                                          return (
                                                            <Row
                                                              key={i}
                                                              className="table_content mt-1"
                                                            >
                                                              {/* NAME */}
                                                              <Col
                                                                lg={5}
                                                                md={5}
                                                                sm={5}
                                                                xs={5}
                                                                className="mt-3 master-couple"
                                                              >
                                                                <h3>
                                                                  <span
                                                                    style={{
                                                                      marginRight:
                                                                        "10px",
                                                                      fontSize:
                                                                        "12px",
                                                                    }}
                                                                  >
                                                                    ●
                                                                  </span>

                                                                  {item.role ===
                                                                  "Spiritual Director"
                                                                    ? `${item.title ? `${item.title} ` : ""}${item?.firstName || ""} ${
                                                                        item?.lastName ||
                                                                        ""
                                                                      }`
                                                                    : isBothPresent
                                                                      ? `${item.hisFirstName} & ${item.herFirstName} ${
                                                                          item.hisLastName ||
                                                                          ""
                                                                        }`
                                                                      : item?.hisFirstName
                                                                        ? `${item.hisFirstName} ${
                                                                            item.hisLastName ||
                                                                            ""
                                                                          }`
                                                                        : item?.herFirstName
                                                                          ? `${item.herFirstName} ${
                                                                              item.herLastName ||
                                                                              ""
                                                                            }`
                                                                          : ""}
                                                                </h3>
                                                              </Col>

                                                              {/* ROLE */}
                                                              <Col
                                                                lg={5}
                                                                md={5}
                                                                sm={5}
                                                                xs={5}
                                                                className="mt-3 master-couple"
                                                              >
                                                                <h3>
                                                                  {item.role ===
                                                                  "Spiritual Director"
                                                                    ? tp(
                                                                        "spiritual_director",
                                                                      )
                                                                    : item.role ===
                                                                        "Spiritual Mentor"
                                                                      ? isBothPresent
                                                                        ? tp(
                                                                            "spiritual_mentor_couple",
                                                                          )
                                                                        : tp(
                                                                            "spiritual_mentor",
                                                                          )
                                                                      : item.role
                                                                        ? isSpanish
                                                                          ? `Pareja ${item.spanishRole || item.role}`
                                                                          : `${item.role} Couple`
                                                                        : ""}
                                                                </h3>
                                                              </Col>

                                                              {/* DELETE */}
                                                              <Col
                                                                lg={2}
                                                                md={2}
                                                                sm={2}
                                                                xs={2}
                                                                className="mt-2"
                                                              >
                                                                <button
                                                                  onClick={() =>
                                                                    handleShow(
                                                                      item,
                                                                    )
                                                                  }
                                                                  className="font-size delete-icon"
                                                                >
                                                                  <i
                                                                    className="mdi mdi-delete-forever text-md mx-2 font-size"
                                                                    title="Delete"
                                                                  ></i>
                                                                </button>
                                                              </Col>
                                                            </Row>
                                                          );
                                                        })}
                                                    </React.Fragment>
                                                  );
                                                });
                                              })()}
                                            <PageNumber pageKey="supportTeams" />
                                          </Container>
                                        </Col>
                                      ) : null}
                                      {program && program.wisdom_from_mt ? (
                                        <Col
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                          id="section-wisdom"
                                          className="colorTalks mt-3"
                                        >
                                          <div className="howerOption">
                                            <h3 className="mb-0 model_data">
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    program &&
                                                    program.wisdom_from_mt,
                                                }}
                                              />
                                            </h3>
                                          </div>
                                          <PageNumber pageKey="wisdom" />
                                        </Col>
                                      ) : null}
                                      <Col
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        id="section-guidelines"
                                        className="colorTalks mt-3"
                                      >
                                        <div className="text-center">
                                          <img
                                            src={lovestrongLogo}
                                            alt=""
                                            srcset=""
                                            className="logo_image1 mt-4"
                                          />
                                          <h3
                                            style={{
                                              color: "#d2b74c",
                                              fontWeight: "700",
                                            }}
                                          >
                                            {tp("ministry")}
                                          </h3>
                                          <h5 className="mt-2 mb-3">
                                            <em
                                              style={{
                                                color: "#d2b74c",
                                                fontWeight: "700",
                                              }}
                                            >
                                              {tp("live_love_strong")}
                                            </em>
                                          </h5>
                                          <div className="howerOption">
                                            <h3
                                              className="mb-4 roaster_list"
                                              style={{
                                                textAlign: "left",
                                              }}
                                            >
                                              {program && program.guidelines ? (
                                                <div
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      program &&
                                                      program.guidelines,
                                                  }}
                                                />
                                              ) : null}
                                            </h3>
                                          </div>
                                        </div>
                                        <PageNumber pageKey="guidelines" />
                                      </Col>
                                      {roasterData &&
                                        roasterData[1] &&
                                        roasterData[1].speakers &&
                                        roasterData[1].speakers.map(
                                          (item, i) => {
                                            return item ? (
                                              <Col
                                                lg={12}
                                                md={12}
                                                sm={12}
                                                xs={12}
                                                id={`section-talk_${i}`}
                                                className="colorTalks mt-3 pt-5 text-center talk-worksheet-page"
                                                key={i}
                                              >
                                                <button
                                                  type="button"
                                                  className="talk-worksheet-edit"
                                                  title={t("talk_questions")}
                                                  onClick={() =>
                                                    openTalkWorksheet(item, i)
                                                  }
                                                >
                                                  <i className="mdi mdi-pencil" />
                                                </button>
                                                <TalkWorksheet
                                                  title={talkHeading(item, {
                                                    label: tp("talk"),
                                                    index: i,
                                                    isSpanish,
                                                  })}
                                                  speakerName={speakerDisplayName(
                                                    item,
                                                  )}
                                                  bannerColor={
                                                    endingPageBgColor ||
                                                    "#1f4e7a"
                                                  }
                                                  content={item.talk_question}
                                                />
                                                <PageNumber
                                                  pageKey={`talk_${i}`}
                                                />
                                              </Col>
                                            ) : null;
                                          },
                                        )}
                                      <Col
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        id="section-parishMission"
                                        className="colorTalks mt-3"
                                      >
                                        <div
                                          className="parishHeading text-center"
                                          style={{
                                            backgroundColor:
                                              endingPageBgColor || "#1f4e7a",
                                          }}
                                        >
                                          <h3>
                                            {isSpanish
                                              ? data?.myparish?.spanishParish ||
                                                program?.parishName
                                              : program?.parishName}
                                          </h3>
                                        </div>

                                        <div className="howerOption">
                                          <h2
                                            className="mb-4 model_data"
                                            style={{
                                              textAlign: "left",
                                            }}
                                          >
                                            {program &&
                                            program.parishMission ? (
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    program &&
                                                    program.parishMission,
                                                }}
                                              />
                                            ) : (
                                              ""
                                            )}
                                          </h2>
                                        </div>

                                        <Row className="align-items-start mt-4 justify-content-center">
                                          {(program?.parishName ||
                                            program?.parishAddress ||
                                            program?.parishLink ||
                                            program?.parishImageUrl) && (
                                            <Col
                                              lg={12}
                                              md={12}
                                              sm={6}
                                              xs={12}
                                              className="parishDetail text-center"
                                            >
                                              {program?.parishImageUrl &&
                                              program?.parishLink ? (
                                                <a
                                                  href={program.parishLink}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                >
                                                  <img
                                                    src={program.parishImageUrl}
                                                    alt=""
                                                    className="parishLogo1"
                                                  />
                                                </a>
                                              ) : (
                                                program?.parishImageUrl && (
                                                  <img
                                                    src={program.parishImageUrl}
                                                    alt=""
                                                    className="parishLogo1"
                                                  />
                                                )
                                              )}
                                              {program?.parishName && (
                                                <h3 className="mt-2">
                                                  {isSpanish
                                                    ? data?.myparish
                                                        ?.spanishParish ||
                                                      program?.parishName
                                                    : program?.parishName}
                                                </h3>
                                              )}

                                              <h5>
                                                {[
                                                  program?.parishAddress,
                                                  program?.parishCity,
                                                  program?.parishState,
                                                  program?.parishzip,
                                                ]
                                                  .filter(Boolean)
                                                  .join(", ")}
                                              </h5>

                                              {program?.parishLink && (
                                                <h5>
                                                  <a
                                                    href={program.parishLink}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                  >
                                                    {program.parishLink}
                                                  </a>
                                                </h5>
                                              )}
                                            </Col>
                                          )}
                                        </Row>

                                        <Row className="parishes-logos">
                                          <Col
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            className="mt-3 mb-3 text-center"
                                          >
                                            <img
                                              src={lovestrongLogo}
                                              alt=""
                                              srcset=""
                                              className="logo_image5"
                                            />
                                            <h5 className="mt-2 mb-3">
                                              <em
                                                style={{
                                                  color: "#d2b74c",
                                                  fontWeight: "700",
                                                }}
                                              >
                                                {tp("live_love_strong")}
                                              </em>
                                            </h5>

                                            <a
                                              href="https://lovestrong.koolderbyacademy.com"
                                              style={{
                                                textDecoration: "none",
                                              }}
                                            >
                                              {" "}
                                              <div className="lovestrongLinkWrap">
                                                <div className="lovestrongLinkLine" />
                                                <h4
                                                  style={{
                                                    color: "black",
                                                    fontWeight: "700",
                                                    textDecoration: "none",
                                                    margin: 0,
                                                  }}
                                                  className="lovestrongLink"
                                                >
                                                  www.LOVESTRONGMarriage.com
                                                </h4>
                                              </div>
                                            </a>
                                          </Col>
                                        </Row>

                                        <Row className="align-items-start mt-4 justify-content-center mb-2">
                                          <Col
                                            lg={2}
                                            md={3}
                                            sm={6}
                                            xs={12}
                                            className="text-center"
                                          >
                                            {program?.fbLink ? (
                                              <a
                                                href={program.fbLink}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                <img
                                                  src={fbIcon}
                                                  alt={tp("facebook_link")}
                                                  className="logo_image1 socialLinkIconFacebook"
                                                />
                                              </a>
                                            ) : (
                                              <img
                                                src={fbIcon}
                                                alt={tp("facebook_link")}
                                                className="logo_image1 socialLinkIconFacebook"
                                              />
                                            )}
                                          </Col>

                                          <Col
                                            lg={2}
                                            md={3}
                                            sm={6}
                                            xs={12}
                                            className="text-center"
                                          >
                                            {program?.instaLink ? (
                                              <a
                                                href={program.instaLink}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                <img
                                                  src={instaIcon}
                                                  alt={tp("instagram_link")}
                                                  className="logo_image1 socialLinkIcon"
                                                />
                                              </a>
                                            ) : (
                                              <img
                                                src={instaIcon}
                                                alt={tp("instagram_link")}
                                                className="logo_image1 socialLinkIcon"
                                              />
                                            )}
                                          </Col>
                                          <PageNumber pageKey="parishMission" />
                                        </Row>
                                      </Col>

                                      {/* ── PRAYER OF PROTECTION ── */}
                                      <Col
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        id="section-prayerOfProtection"
                                        className="colorTalks mt-3"
                                      >
                                        <div className="howerOption">
                                          <h2
                                            className="mb-1 model_data"
                                            style={{ textAlign: "left" }}
                                          >
                                            {program?.prayer_of_protection ? (
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    program.prayer_of_protection,
                                                }}
                                              />
                                            ) : (
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html: tp(
                                                    "prayer_protection_content",
                                                  ),
                                                }}
                                              />
                                            )}
                                            <div className="text-center mt-5">
                                              {" "}
                                              <img
                                                src={lovestrongLogo}
                                                alt=""
                                                className="program_logo"
                                              />
                                            </div>
                                          </h2>
                                        </div>

                                        <PageNumber pageKey="prayerOfProtection" />
                                      </Col>

                                      {/* ── DONATIONS ── */}
                                      <Col
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        id="section-donations"
                                        className="colorTalks mt-3"
                                      >
                                        <div className="howerOption">
                                          <h2
                                            className="model_data"
                                            style={{ textAlign: "left" }}
                                          >
                                            <div className="text-center">
                                              {" "}
                                              <img
                                                src={lovestrongLogo}
                                                alt=""
                                                className="program_logo mt-3 "
                                              />{" "}
                                              <h4
                                                style={{
                                                  color: "#d2b74c",
                                                  fontWeight: "700",
                                                }}
                                              >
                                                {tp("ministry")}
                                              </h4>
                                              <h4 className="mt-3 mb-4">
                                                <em
                                                  style={{
                                                    color: "#d2b74c",
                                                    fontWeight: "700",
                                                  }}
                                                >
                                                  {tp("live_love_strong")}
                                                </em>
                                              </h4>
                                            </div>

                                            {program?.donations ? (
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html: program.donations,
                                                }}
                                              />
                                            ) : (
                                              <div
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    tp("donations_content"),
                                                }}
                                              />
                                            )}
                                          </h2>
                                        </div>
                                        <div className="text-center mb-2">
                                          <img
                                            src={
                                              program?.qrCodeImage ||
                                              defaultQrCode
                                            }
                                            alt="Scan for more information"
                                            style={{
                                              maxWidth: "200px",
                                              height: "auto",
                                            }}
                                          />
                                        </div>

                                        <PageNumber pageKey="donations" />
                                      </Col>

                                      {program &&
                                      program.footerImages &&
                                      program.footerImages.length > 0 ? (
                                        <Col
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                          className=" colorTalks mt-3 howerOption"
                                        >
                                          {program &&
                                            program.footerImages &&
                                            program.footerImages.length > 0 &&
                                            program.footerImages.map(
                                              (item, index) => {
                                                return (
                                                  <Col
                                                    lg={12}
                                                    md={12}
                                                    sm={12}
                                                    xs={12}
                                                    id={`section-footer_${index}`}
                                                    className="mb-5 howerOption mainHeaderImage"
                                                    key={index}
                                                  >
                                                    <>
                                                      <div className="text-center">
                                                        <img
                                                          src={item}
                                                          className="imageHeader"
                                                        />
                                                      </div>
                                                      <div className="text-center setUploadField">
                                                        <button
                                                          className="middle_Icon3 button-18"
                                                          onClick={() =>
                                                            deleteFooterFile(
                                                              program,
                                                              item,
                                                            )
                                                          }
                                                        >
                                                          {t("remove")}
                                                        </button>
                                                      </div>
                                                      <PageNumber
                                                        pageKey={`footer_${index}`}
                                                      />
                                                    </>
                                                  </Col>
                                                );
                                              },
                                            )}
                                        </Col>
                                      ) : null}

                                      <Col
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        className="colorTalks mt-3 p-5 howerOption program-section program-ending-page"
                                        id="section-endingPage"
                                        style={{
                                          backgroundColor: endingPageBgColor,
                                        }}
                                      >
                                        <div
                                          style={{
                                            textAlign: "center",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "24px",
                                            flex: 1,
                                            width: "100%",
                                          }}
                                        >
                                          <div style={{ marginBottom: "20px" }}>
                                            <img
                                              src={lovestrongLogo}
                                              alt={tp("lovestrong_marriage")}
                                              className="program_logo"
                                              style={{
                                                maxWidth: "340px",
                                                height: "auto",
                                                filter:
                                                  "drop-shadow(0 4px 8px rgba(0,0,0,0.3))",
                                              }}
                                            />
                                          </div>

                                          <div
                                            style={{
                                              backgroundColor: "white",
                                              padding: "18px",
                                              borderRadius: "10px",
                                              boxShadow:
                                                "0 10px 24px rgba(0,0,0,0.18)",
                                              display: "inline-block",
                                            }}
                                          >
                                            <img
                                              src={
                                                program?.qrCodeImage ||
                                                defaultQrCode
                                              }
                                              alt={tp("scan_for_more_info")}
                                              style={{
                                                maxWidth: "200px",
                                                height: "auto",
                                                display: "block",
                                              }}
                                            />
                                          </div>
                                          <div
                                            data-html2canvas-ignore="true"
                                            style={{ marginTop: "15px" }}
                                          >
                                            <Button
                                              onClick={() => {
                                                const url =
                                                  program?.qrCodeImage ||
                                                  defaultQrCode;
                                                fetch(url)
                                                  .then((response) =>
                                                    response.blob(),
                                                  )
                                                  .then((blob) => {
                                                    const link =
                                                      document.createElement(
                                                        "a",
                                                      );
                                                    link.href =
                                                      URL.createObjectURL(blob);
                                                    link.download =
                                                      "LoveStrong_QR_Code.png";
                                                    document.body.appendChild(
                                                      link,
                                                    );
                                                    link.click();
                                                    document.body.removeChild(
                                                      link,
                                                    );
                                                  })
                                                  .catch(() => {
                                                    const link =
                                                      document.createElement(
                                                        "a",
                                                      );
                                                    link.href = url;
                                                    link.download =
                                                      "LoveStrong_QR_Code.png";
                                                    link.target = "_blank";
                                                    document.body.appendChild(
                                                      link,
                                                    );
                                                    link.click();
                                                    document.body.removeChild(
                                                      link,
                                                    );
                                                  });
                                              }}
                                              style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: "7px",
                                                backgroundColor: "#9b8427",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "6px",
                                                padding: "6px 10px",
                                                fontSize: "14px",
                                                fontWeight: 500,
                                                cursor: "pointer",
                                                boxShadow:
                                                  "0 2px 8px rgba(155,132,39,0.28)",
                                                transition:
                                                  "background 0.15s, transform 0.1s, box-shadow 0.15s",
                                              }}
                                              onMouseEnter={(e) =>
                                                (e.currentTarget.style.backgroundColor =
                                                  "#b39830")
                                              }
                                              onMouseLeave={(e) =>
                                                (e.currentTarget.style.backgroundColor =
                                                  "#9b8427")
                                              }
                                            >
                                              <i className="mdi mdi-download align-middle mt-1"></i>{" "}
                                              {tp("download_qr_code")}
                                            </Button>
                                          </div>
                                        </div>
                                        <PageNumber pageKey="endingPage" />
                                      </Col>
                                    </Row>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </div>
            </div>
          </div>
        </div>
        {modalProramShow ? (
          <ProgramModel
            show={modalProramShow}
            programField={nameModel}
            program={program}
            retreatData={data}
            coupleTalkData={coupleTalkData}
            onHide={() => closeProgramModel()}
          />
        ) : null}{" "}
        <TalkWorksheetEditor
          show={!!worksheetTalk}
          talk={worksheetTalk?.item}
          talkIndex={worksheetTalk?.index || 0}
          retreat={data}
          program={program}
          bannerColor={endingPageBgColor || "#1f4e7a"}
          onHide={() => setWorksheetTalk(null)}
          onSaved={() => getAllRoastersInfo(id)}
        />
        {showDelete ? (
          <DeleteModel
            show={showDelete}
            handleClose={handleClose}
            DeleteData={deleteRoasterCouple}
          ></DeleteModel>
        ) : null}
        {showColorAlert ? (
          <AlertConfirm
            show={showColorAlert}
            alertHeader={t("alert")}
            alertMessage={t("confirm_color_change")}
            handleClose={() => setShowColorAlert(false)}
            handleConfirm={() => {
              updateEndingPageBgColor(tempColor);
              setShowColorAlert(false);
            }}
            confirmText={t("yes")}
            cancelText={t("no")}
          />
        ) : null}
      </div>
    </>
  );
};
